/**
 * The sender's draft on the care-package share screen: note, contact, To.
 *
 * Kept per reading in localStorage until the package is sent, so a click
 * outside the sheet, a closed tab or a reload never costs them the letter
 * they wrote. Every read and write is guarded: storage can be absent.
 */
const KEY = (rid) => `care-draft:${rid}`

export function saveDraft(rid, draft) {
  if (!rid) return
  try { localStorage.setItem(KEY(rid), JSON.stringify(draft || {})) } catch (e) { /* no storage */ }
}

export function loadDraft(rid) {
  if (!rid) return null
  try {
    const raw = localStorage.getItem(KEY(rid))
    if (!raw) return null
    const d = JSON.parse(raw)
    return d && typeof d === 'object' ? d : null
  } catch (e) { return null }
}

export function clearDraft(rid) {
  if (!rid) return
  try { localStorage.removeItem(KEY(rid)) } catch (e) { /* no storage */ }
}
